import { Col, Form } from "react-bootstrap"
import { toast } from "react-toastify"
import { useState } from "react";
import hocFrom from "components/forms/HocFrom"
import InputControl from "components/inputs/InputControl"
import Switchrs from "components/inputs/Switchrs"
import Loader from "components/layout/Loader"
import InputDate from "components/inputs/InputDate";
import NumberFormat from "react-number-format";
import { Space } from "antd";
import toaster from "helper/toaster";

function FormOrderFacility({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata }) {

    const [fromDate, setFromDate] = useState()
    const [toDate, setToDate] = useState()

    const handelValue = (name, value) => {
        switch (name) {
            case 'isActive':
                handelsetdataForm({ ...formdata, isActive: value })
                break;
            case 'title':
                handelsetdataForm({ ...formdata, title: value })
                break;
            case 'inputTitle':
                handelsetdataForm({ ...formdata, inputTitle: value })
                break;
            case 'description':
                handelsetdataForm({ ...formdata, description: value })
                break;
            case 'fromDate':
                setFromDate(value)
                handelsetdataForm({ ...formdata, fromDate: `${value}` })
                break;
            case 'toDate':
                setToDate(value)
                handelsetdataForm({ ...formdata, toDate: `${value}` })
                break;
            case 'price':
                handelsetdataForm({ ...formdata, price: parseInt(value) })
                break;
            case 'companyId':
                handelsetdataForm({ ...formdata, companyId: value })
                break;
            case 'businessType':
                handelsetdataForm({ ...formdata, businessType: value })
                break;
            case 'orderFacilityType':
                handelsetdataForm({ ...formdata, orderFacilityType: value })
                break;
            default:
                break;
        }
    }
    const handelSubmit = event => {
        event.preventDefault()

        handelLoadingform(true);

        if (formdata?.businessType === null || formdata?.businessType === undefined) {
            return toaster.error('لطفا نوع زیرسیستم را انتخاب کنید.');
        }

        if (formdata?.orderFacilityType === null || formdata?.orderFacilityType === undefined) {
            return toaster.error('لطفا نوع امکانات را انتخاب کنید.');
        }

        if (formdata?.businessType === 1 && !formdata?.companyId) {
            return toaster.error('لطفا شرکت را انتخاب کنید.');
        }

        if (!formdata.title) {
            toast.error("لطفا عنوان را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.fromDate === undefined) {
            toast.error("لطفا تاریخ شروع را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.toDate === undefined) {
            toast.error("لطفا تاریخ پایان را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.price === undefined) {
            toast.error("لطفا هزینه را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            dataUpdate.title ? handelUpdataFrom() : handelSend()
        }
    }


    return (
        <>
            {loding ?
                <Loader />
                :
                <Form method='post' >
                    <Form.Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>عنوان</Form.Label>
                                <Form.Control type="text" name='title' defaultValue={dataUpdate.title} onChange={(event) => handelValue('title', event.target.value)} />
                            </Form.Group>
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <Col>
                            <InputControl
                                hasDefValueOnPurpose
                                label='نوع امکانات'
                                name='orderFacilityType'
                                defaultValue={dataUpdate?.orderFacilityType}
                                url='/common/getOrderFacilityType'
                                handelValue={(_, value) => handelValue('orderFacilityType', value)}
                            />
                        </Col>
                        <Col>
                            <InputControl
                                hasDefValueOnPurpose
                                label='نوع زیرسیستم'
                                name='businessType'
                                defaultValue={dataUpdate?.businessType}
                                url='/common/getSubSystemType'
                                handelValue={(_, value) => handelValue('businessType', value)}
                            />
                        </Col>
                        <Col>
                            {(formdata?.businessType === 1 || dataUpdate?.businessType === 1 || dataUpdate?.companyId) &&
                                <InputControl
                                    url='/businessCompany/getDropdown'
                                    label='شرکت'
                                    name='companyId'
                                    defaultValue={dataUpdate?.companyId}
                                    handelValue={(_, value) => handelValue('companyId', value)}
                                />
                            }
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <Col>
                            <Space direction={'vertical'} style={{ width: '100%' }}>
                                <small> هزینه (ريال)</small>
                                <NumberFormat
                                    thousandSeparator={','}
                                    autoComplete={'off'}
                                    defaultValue={dataUpdate?.price}
                                    decimalSeparator={'-'}
                                    dir='ltr'
                                    onChange={(e) => {
                                        const value = parseInt(
                                            e.target.value.replace(/,/g, '')
                                        );
                                        handelValue('price', value);
                                    }}
                                    style={{
                                        height: '50px',
                                        width: '100%',
                                        border: 'none !important',
                                    }}
                                />
                            </Space>
                        </Col>
                        <Col>
                            <InputDate label='از تاریخ' name='fromDate' handelValue={handelValue}
                                defaultValue={dataUpdate.hasOwnProperty('fromDate') ? dataUpdate.fromDate.split("T")[0] : ''} />
                        </Col>

                        <Col>
                            <InputDate label='تا تاریخ' name='toDate' handelValue={handelValue}
                                defaultValue={dataUpdate.hasOwnProperty('toDate') ? dataUpdate.toDate.split("T")[0] : ''} />
                        </Col>

                    </Form.Row>
                    <Form.Row>

                        <Col>
                            <div className="form-group">
                                <label htmlFor="descriptionTextarea">توضیحات</label>
                                <textarea className="form-control" id="descriptionTextarea" rows="6" defaultValue={dataUpdate ? dataUpdate.description : ''} onChange={(e) => handelValue('description', e.target.value)} ></textarea>
                            </div>
                        </Col>

                    </Form.Row>

                    <Form.Row className='mb-4'>

                        <Switchrs
                            label='آیا فعال باشد؟'
                            name='isActive'
                            checke={formdata.isActive}
                            handelValue={handelValue}
                        />
                    </Form.Row>
                    <Form.Row>
                        <Col>
                            <button type='submit'
                                className='btn btn-success'
                                onClick={handelSubmit}
                                disabled={LoadingForm} >
                                {LoadingForm ?
                                    <i className="fa fa-spinner fa-pulse fa-fw"></i>
                                    : dataUpdate.title ? "ثبت ویرایش" : "ثبت"}
                            </button>
                        </Col>
                    </Form.Row>
                </Form>
            }
        </>
    )
}
export default hocFrom(FormOrderFacility)